import React, { useContext, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import AppContext from "../../hooks/appContext";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import debounce from 'lodash.debounce';
import { formatToMoney } from "../../utils/helpers";

const FilterModal = (props) => {
  
  const {
    allStoreCategories,
    currentCategory,
    setCurrentCategory,
    currentCurrency,
    filterParams,
    setFilterParams,

    filterModalShow,
    setFilterModalShow,
    toggleFilterModal,
    hideFilterModal,
    showFilterModal,
  } = useContext(AppContext);

  const options = [
    {value: "none", label: "Sort By"},
    {value: "ASC", label: "Price: Low to High"},
    {value: 'DESC', label: "Price: High to Low"},
  ]

  const handleCategoryClick = (category) => {
    setCurrentCategory(category);

    if (category === "all") {
      setFilterParams({ ...filterParams, category: "" });
    } else {
      setFilterParams({ ...filterParams, category: category });
    }

    hideFilterModal();
  }

  const handleChangeSortOrder = (order) => {
    if (order === "ASC") {
      setFilterParams({ ...filterParams, priceOrder: "ASC" })
    } else if (order === "DESC") {
      setFilterParams({ ...filterParams, priceOrder: "DESC" })
    } else if (order === "none") {
      setFilterParams({ ...filterParams, priceOrder: null })
    }

    hideFilterModal();
  }

  const [priceFilterMax, setPriceFilterMax] = useState(1000000);
  const handleChangePriceRange = (order) => {
    setPriceFilterMax(order);

    debouncedPriceRangeHandler(order);
  }

  const handlePriceRangeFilter = (price) => {
    setFilterParams({ ...filterParams, priceRange: price });

    hideFilterModal();
  }

  const debouncedPriceRangeHandler = useMemo(
    (price) => debounce(handlePriceRangeFilter, 400)
  , []);


  // const showHideClassName = props.show ? "filter-modal display-block" : "filter-modal display-none";
  const showHideClassName = props.show ? `${styles['filter-modal']} ${styles['display-block']}` : `${styles['filter-modal']} ${styles['display-none']}`;
  const showHideModalName = props.show ? `${styles['filter-modal-main']} ${styles.open}` : `${styles['filter-modal-main']} ${styles.close}`;

  const allCategoryClasses = `${styles.category} ${currentCategory === "all" ? styles.active : ""}`
  // const otherCategoryClasses = `${styles.category} ${currentCategory.toLowerCase() === cat.slug.toLowerCase() ? styles.active : ""}`
  const getOtherCategoryClasses = (cat) => {
    return `${styles.category} ${currentCategory.toLowerCase() === cat.slug.toLowerCase() ? styles.active : ""}`
  }

  return (
    <>
      <div className={showHideClassName}>
        <div className={showHideModalName}>
          <div className={styles['modal-content']}>
            <div className={styles['modal-header']}>
              Filters
              <div className={styles['modal-close']} onClick={hideFilterModal}>
                <CloseOutlinedIcon />
              </div>
            </div>

            <div className={styles['modal-body']}>
              <div className={styles['filter-card-body']}>
                <div className={styles['sort-filter']}>
                  <div className={styles['filter-title']}>Sort By</div>

                  <select name="order-select" className={styles['order-select']} value={filterParams?.priceOrder || "none"} onChange={(e) => handleChangeSortOrder(e.target.value)}>
                    {
                      options.map((option, id) => (
                        <option value={option.value} key={id}>{option.label}</option>
                      ))
                    }
                  </select>
                </div>

                <div className={styles['category-filter']}>
                  <div className={styles['filter-title']}>Product Categories</div>
                  <div className={styles['title-divider']}></div>
                  <div className={styles['category-list']}>
                    <div className={allCategoryClasses} onClick={() => handleCategoryClick("all")}>All</div>
                    {
                      allStoreCategories?.map((cat, id) => (
                        <div className={getOtherCategoryClasses(cat)}
                          key={id}
                          onClick={() => handleCategoryClick(cat.slug)}>
                          {cat.name}
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FilterModal;